var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.directMessages && _vm.directMessages.length)?_c('div',{staticClass:"u-marginBottom6"},_vm._l((_vm.directMessages),function(message){return _c('div',{key:message.id},[_c('DirectMessage',{staticClass:"u-marginBottom2",attrs:{"message":message}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }